module.exports = __webpack_public_path__ + "img/32.f7d1183e.png";